import {
  Box,
  Flex,
  Spinner,
  Table,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
  Text,
} from "@chakra-ui/react";
import TrackingPageLayout from "components/TrackingPageLayout";
import { useParentPayments } from "hooks/useTrackingPayments";

function formatDate(s: string | null | undefined) {
  if (!s) return "—";
  return new Date(s).toLocaleString("fr-FR");
}

function formatAmount(value: number | string | undefined) {
  if (value == null) return "—";
  const n = typeof value === "string" ? parseFloat(value) : value;
  return Number.isNaN(n) ? "—" : `${n.toFixed(2)} FCFA`;
}

export default function TrackingParentPaymentsPage() {
  const { payments, isLoading, error } = useParentPayments();

  return (
    <TrackingPageLayout title="Paiements (tous mes élèves)">
      {error && (
        <Text color="red.600" mb={3} px={4} pt={4}>
          Erreur lors du chargement des paiements.
        </Text>
      )}
      {isLoading ? (
        <Flex justify="center" py={8}><Spinner /></Flex>
      ) : (payments?.length ?? 0) === 0 ? (
        <Box p={8} textAlign="center"><Text color="gray.600">Aucun paiement enregistré.</Text></Box>
      ) : (
        <Box overflowX="auto" px={4} pb={4}>
          <Table size="sm">
          <Thead>
            <Tr>
              <Th>Élève</Th>
              <Th>Montant</Th>
              <Th>Méthode</Th>
              <Th>Statut</Th>
              <Th>Date</Th>
            </Tr>
          </Thead>
          <Tbody>
            {payments.map((p: any) => (
              <Tr key={p.id}>
                <Td>{p.student_name ?? "—"}</Td>
                <Td>{formatAmount(p.amount)}</Td>
                <Td>{p.payment_method_display ?? p.payment_method ?? "—"}</Td>
                <Td>{p.status_display ?? p.status ?? "—"}</Td>
                <Td>{formatDate(p.created_at)}</Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
        </Box>
      )}
    </TrackingPageLayout>
  );
}

